<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="common-limit">
      <div class="table-body">
        <div style="overflow:hidden;margin: 0 0 8px 0;">
          <div class="left">
            <el-button
              @click="handleShowDialog(null)"
              type="primary"
              size="small"
              >新增</el-button
            >
          </div>
          <div class="right">
            <pagination
              v-show="total > 0"
              :total="total"
              :page.sync="form.pageNum"
              :page-size="form.pageSize"
              :page-sizes="[100, 200, 300, 400]"
              @pagination="loadData"
            />
          </div>
        </div>
        <el-table
          id="outTable"
          border
          :data="tableData"
          style="width: 100%"
          lazy
        >
          <!-- <el-table-column type="selection" width="40" align="center"></el-table-column> -->
          <el-table-column label="属性名" prop="fieldName" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.fieldName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="是否启用" prop="isUse" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.isUse == "1" ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="oper" fixed="right" width="160">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="handleShowDialog(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="mini"
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="form.pageNum"
          :page-size="form.pageSize"
          :page-sizes="[100, 200, 300, 400]"
          @pagination="loadData"
        />
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  
      :title="dialogTitle"
      width="50%"
      :visible.sync="noteDialogVisible"
      class="note-dialog"
    >
      <el-row>
        <el-col>
          <el-form
            ref="form"
            :model="form"
            label-position="left"
            label-width="100px"
          >
            <el-form-item prop="fieldName" label="属性名：" required>
              <el-input
                v-model="form.fieldName"
                placeholder="请输入属性名"
                clearable
                size="small"
              />
            </el-form-item>
            <el-form-item prop="isUse" label="是否启用：" required>
              <el-radio-group v-model="form.isUse">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSave" size="small"
          >确 定</el-button
        >
        <el-button @click="noteDialogVisible = false" size="small"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  listVarUse,
  editVarUse,
  addVarUse,
  deleteVar,
} from "@/api/sysSupport/var"

export default {
  name: "variableReference",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      noteDialogVisible: false,
      form: {
        fieldName: "",
        isUse: true,
      },
      total: 0,
      loading: false,
      tableData: [],
      dialogTitle: "",
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      let params = {}
      listVarUse(params)
        .then((res) => {
          this.loading = false
          this.total = res.total
          this.tableData = res.rows
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
        })
    },
    handleShowDialog(data) {
      if (!data) {
        this.form = {
          fieldName: "",
          isUse: "1",
        }
        this.dialogTitle = "新增"
      } else {
        this.form = data
        this.dialogTitle = "编辑"
      }
      this.noteDialogVisible = true
    },
    handleSave() {
      let _self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (_self.form.id) {
            editVarUse(_self.form).then((response) => {
              if (response.code == "200") {
                _self.msgSuccess("修改成功！")
                _self.noteDialogVisible = false
                _self.loadData()
              } else {
                _self.msgError("修改失败！")
              }
            })
          } else {
            addVarUse(_self.form).then((response) => {
              if (response.code === 200) {
                _self.msgSuccess("新增成功！")
                _self.noteDialogVisible = false
                _self.loadData()
              } else {
                _self.msgError("新增失败！")
              }
            })
          }
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    handleDelete(row) {
      this.$confirm("确认删除变量？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteVar(row.id).then((response) => {
          if (response.code === 200) {
            this.msgSuccess("删除成功！")
            this.loadData()
          } else {
            this.msgError("删除失败！")
          }
        })
      })
    },
  },
}
</script>

<style scoped></style>
